import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import { MasterDataListRequest, MasterDataListResponse } from "./types";

export const masterDataListService = (params: MasterDataListRequest) =>
  RestAPIClient.call<MasterDataListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      params,
      requireAuthentication: true,
    },
  });
